import { defineMessages } from 'react-intl-next';

export default defineMessages({
    askAtlassianIntelligence: {
        defaultMessage: 'Ask Atlassian Intelligence for help',
        description: 'Text for atlassian intelligence choice on search',
        id: 'search.ask.atlassian.intelligence.non-final',
    },
    seeSearchResults: {
        defaultMessage: 'See search results',
        description: 'Text for searching on all results choice',
        id: 'search.see.search.results.non-final',
    },
    clearLabel: {
        defaultMessage: 'Reset search',
        description: 'Label for icon that clears the search term',
        id: 'search.ask.atlassian.intelligence.input.clear.non-final',
    },
    inputAriaLabel: {
        defaultMessage: 'Question or search terms',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.ask.atlassian.intelligence.input.label.non-final',
    },
    inputPlaceholder: {
        defaultMessage: 'Ask a question or search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.ask.atlassian.intelligence.input.placeholder.non-final',
    },
    inputAriaLabelNoAI: {
        defaultMessage: 'Search terms',
        description: 'ARIA label for textbox that allows asking a question or searching for results',
        id: 'search.ask.atlassian.intelligence.input.label.noai.non-final',
    },
    inputPlaceholderNoAI: {
        defaultMessage: 'Search for information',
        description: 'Placeholder message for the new search bar describing what they can look for',
        id: 'search.ask.atlassian.intelligence.input.placeholder.noai.non-final',
    },
});
